import React from 'react';
import _ from 'lodash';

import PositionedGoodyHOC from '../PositionedGoodyHOC';
import { POSITIONED_GOODY_REFS } from '../../../../constants';

class Cat extends PositionedGoodyHOC {
	// 4
	render() {
		const style = {
			st1: {
				fill: '#EFEFEF',
			},
		};
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="48.5658134" cy="15.4998684" />
				<path style={style.st1} d="M18.165432,30.5141602c-8.2783194,0-15.0136719-6.7353516-15.0136719-15.0141602
					S9.8871126,0.4858398,18.165432,0.4858398c8.2792969,0,15.0146484,6.7353516,15.0146484,15.0141602
					S26.4447289,30.5141602,18.165432,30.5141602z M18.165432,3.4858398c-6.6240225,0-12.0136719,5.3896484-12.0136719,12.0141602
					s5.3896489,12.0141602,12.0136719,12.0141602c6.625,0,12.0146484-5.3896484,12.0146484-12.0141602
					S24.790432,3.4858398,18.165432,3.4858398z" />
				<path style={style.st1} d="M78.1654358,30.3417969c-8.1835938,0-14.8418007-6.6582031-14.8418007-14.8417969
					c0-8.184082,6.6582069-14.8422852,14.8418007-14.8422852c8.1845703,0,14.8427734,6.6582031,14.8427734,14.8422852
					C93.0082092,23.6835938,86.3500061,30.3417969,78.1654358,30.3417969z M78.1654358,3.6577148
					c-6.5292969,0-11.8417969,5.3125-11.8417969,11.8422852s5.3125,11.8417969,11.8417969,11.8417969
					c6.5302734,0,11.8427734-5.3120117,11.8427734-11.8417969S84.6957092,3.6577148,78.1654358,3.6577148z" />
				<path style={style.st1} d="M64.8402405,17.9912109h-8.4209023l-0.0351562-1.4643555
					c-0.0234375-0.7612305-0.4580078-7.4863281-8.0810547-7.4863281c-7.890625,0-8.9345703,7.3261719-8.9746094,7.6381836
					l-0.1699219,1.3066406l-7.3183594,0.0058594v-3h4.7646484c0.9443359-3.6728516,4.1972656-8.9506836,11.6982422-8.9506836
					c7.5097656,0,10.3017578,5.2324219,10.9345703,8.9506836h5.6025429V17.9912109z" />
				<circle style={style.st1} cx="2.3484442" cy="15.4998684" r="2.0086577" />
				<circle style={style.st1} cx="93.6515579" cy="15.4998684" r="2.0086577" />
				<path style={style.st1} d="M18.165432,30.5141602c-8.2783194,0-15.0136719-6.7353516-15.0136719-15.0141602
					S9.8871126,0.4858398,18.165432,0.4858398c8.2792969,0,15.0146484,6.7353516,15.0146484,15.0141602
					S26.4447289,30.5141602,18.165432,30.5141602z M18.165432,3.4858398c-6.6240225,0-12.0136719,5.3896484-12.0136719,12.0141602
					s5.3896489,12.0141602,12.0136719,12.0141602c6.625,0,12.0146484-5.3896484,12.0146484-12.0141602
					S24.790432,3.4858398,18.165432,3.4858398z" />
				<path style={style.st1} d="M78.1654358,30.3417969c-8.1835938,0-14.8418007-6.6582031-14.8418007-14.8417969
					c0-8.184082,6.6582069-14.8422852,14.8418007-14.8422852c8.1845703,0,14.8427734,6.6582031,14.8427734,14.8422852
					C93.0082092,23.6835938,86.3500061,30.3417969,78.1654358,30.3417969z M78.1654358,3.6577148
					c-6.5292969,0-11.8417969,5.3125-11.8417969,11.8422852s5.3125,11.8417969,11.8417969,11.8417969
					c6.5302734,0,11.8427734-5.3120117,11.8427734-11.8417969S84.6957092,3.6577148,78.1654358,3.6577148z" />
				<path style={style.st1} d="M64.8402405,17.9912109h-8.4209023l-0.0351562-1.4643555
					c-0.0234375-0.7612305-0.4580078-7.4863281-8.0810547-7.4863281c-7.890625,0-8.9345703,7.3261719-8.9746094,7.6381836
					l-0.1699219,1.3066406l-7.3183594,0.0058594v-3h4.7646484c0.9443359-3.6728516,4.1972656-8.9506836,11.6982422-8.9506836
					c7.5097656,0,10.3017578,5.2324219,10.9345703,8.9506836h5.6025429V17.9912109z" />
				<circle style={style.st1} cx="2.3484442" cy="15.4998684" r="2.0086577" />
				<circle style={style.st1} cx="93.6515579" cy="15.4998684" r="2.0086577" />
			</g>
		);
	}
}

class Tortoise extends PositionedGoodyHOC {
	// 4
	render() {
		const style = {
			st1: {
				fill: '#EFEFEF',
			},
		};
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="22.7070141" cy="8.311657" />
				<path style={style.st1} d="M35.7696571,16.6233139c-4.5827789,0-8.311388-3.7286081-8.311388-8.311657S31.1868782,0,35.7696571,0
					c4.5833168,0,8.311924,3.7286091,8.311924,8.311657S40.3529739,16.6233139,35.7696571,16.6233139z M35.7696571,1.6607636
					c-3.6669807,0-6.6506252,2.983644-6.6506252,6.6508932s2.9836445,6.6508942,6.6506252,6.6508942
					c3.6675186,0,6.6511612-2.9836445,6.6511612-6.6508942S39.4371758,1.6607636,35.7696571,1.6607636z" />
				<path style={style.st1} d="M9.6341515,16.6233139c-4.5827785,0-8.3113871-3.7286081-8.3113871-8.311657S5.051373,0,9.6341515,0
					c4.5833178,0,8.3119278,3.7286091,8.3119278,8.311657S14.2174692,16.6233139,9.6341515,16.6233139z M9.6341515,1.6607636
					c-3.6669798,0-6.6506238,2.983644-6.6506238,6.6508932s2.983644,6.6508942,6.6506238,6.6508942
					c3.6675196,0,6.6511631-2.9836445,6.6511631-6.6508942S13.301671,1.6607636,9.6341515,1.6607636z" />
				<path style={style.st1} d="M26.6025391,7.9223223c-0.3447266-1.4902344-1.5273438-2.9921875-3.9003906-2.9921875
					s-3.5556641,1.5019531-3.9003906,2.9921875h-1.9277344v1.6020508h3.4082031l0.0185547-0.7797852
					C20.3125,8.374959,20.4814453,6.5326738,22.7021484,6.5326738s2.3896484,1.8422852,2.4013672,2.2099609l0.0185547,0.7817383
					h3.4082031V7.9223223H26.6025391z" />
				<circle style={style.st1} cx="0.8796229" cy="8.3115997" r="0.8796229" />
				<circle style={style.st1} cx="44.5968285" cy="8.3115997" r="0.8796229" />
			</g>
		);
	}
}

class Chicken extends PositionedGoodyHOC {
	// 4
	render() {
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} fill="none" cx="28.90401" cy="10.15376" />
				<circle fill="#EFEFEF" cx="56.28173" cy="10.50982" r="1.40606" />
				<path fill="#EFEFEF" d="M11.91563,21.01982c-5.79482,0-10.50957-4.71475-10.50957-10.50991S6.12081,0,11.91563,0
					c5.79551,0,10.51025,4.71475,10.51025,10.50991S17.71114,21.01982,11.91563,21.01982z M11.91563,2.1
					c-4.63682,0-8.40957,3.77275-8.40957,8.40991s3.77275,8.40991,8.40957,8.40991c4.6375,0,8.41025-3.77275,8.41025-8.40991
					S16.55313,2.1,11.91563,2.1z" />
				<path fill="#EFEFEF" d="M45.89178,20.89917c-5.72852,0-10.38926-4.66074-10.38926-10.38926
					c0-5.72886,4.66074-10.3896,10.38926-10.3896c5.7292,0,10.38994,4.66074,10.38994,10.3896
					C56.28173,16.23843,51.62099,20.89917,45.89178,20.89917z M45.89178,2.22031c-4.57051,0-8.28926,3.71875-8.28926,8.2896
					s3.71875,8.28926,8.28926,8.28926c4.57119,0,8.28994-3.71841,8.28994-8.28926S50.46298,2.22031,45.89178,2.22031z" />
				<circle fill="#EFEFEF" cx="1.40606" cy="10.50982" r="1.40606" />
				<path fill="#EFEFEF" d="M34.35794,9.21826c-0.44434-2.10986-2.08887-4.27783-5.4541-4.27783
					c-3.36621,0-5.00977,2.16797-5.45312,4.27783h-2.72559v1.9834h4.56836l0.02246-0.96582
					c0.01172-0.33887,0.20508-3.31201,3.58789-3.31201c3.3916,0,3.57715,2.97266,3.58691,3.30957l0.02344,0.96826h4.56934v-1.9834
					H34.35794z" />
			</g>
		);
	}
}

class Bunny extends PositionedGoodyHOC {
	// 4
	render() {
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="39.98662" cy="14.29694" />
				<path fill="#EFEFEF" d="M63.66008,29.05507c-8.01001,0-14.52707-6.51705-14.52707-14.52754S55.65006,0,63.66008,0
					c8.01096,0,14.52801,6.51705,14.52801,14.52754S71.67104,29.05507,63.66008,29.05507z M63.66008,2.90277
					c-6.40933,0-11.6243,5.21496-11.6243,11.62477s5.21497,11.62477,11.6243,11.62477c6.41028,0,11.62524-5.21496,11.62524-11.62477
					S70.07036,2.90277,63.66008,2.90277z" />
				<path fill="#EFEFEF" d="M16.52867,29.05507c-8.01001,0-14.52707-6.51705-14.52707-14.52754S8.51865,0,16.52867,0
					c8.01096,0,14.52801,6.51705,14.52801,14.52754S24.53962,29.05507,16.52867,29.05507z M16.52867,2.90277
					c-6.40933,0-11.6243,5.21496-11.6243,11.62477s5.21496,11.62477,11.6243,11.62477c6.41028,0,11.62524-5.21496,11.62524-11.62477
					S22.93894,2.90277,16.52867,2.90277z" />
				<path fill="#EFEFEF" d="M46.91214,13.84704c-0.60253-2.60471-2.66957-5.2299-6.8173-5.2299s-6.21477,2.62519-6.8173,5.2299
					h-3.36939v2.80015h5.95703l0.03243-1.36295c0.02048-0.64606,0.31577-3.8661,4.19723-3.8661s4.17675,3.22004,4.19723,3.86268
					l0.03243,1.36636h5.95703v-2.80015H46.91214z" />
				<circle fill="#EFEFEF" cx="1.53745" cy="14.52744" r="1.53745" />
				<circle fill="#EFEFEF" cx="78.65224" cy="14.52744" r="1.53745" />
			</g>
		);
	}
}

class Pig extends PositionedGoodyHOC {
	render() {
		const style = {
			st1: {
				fill: '#EFEFEF',
			},
		};
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="48.2658134" cy="15" />
				<path style={style.st1} d="M18.165432,30.5141602c-8.2783194,0-15.0136719-6.7353516-15.0136719-15.0141602
					S9.8871126,0.4858398,18.165432,0.4858398c8.2792969,0,15.0146484,6.7353516,15.0146484,15.0141602
					S26.4447289,30.5141602,18.165432,30.5141602z M18.165432,3.4858398c-6.6240225,0-12.0136719,5.3896484-12.0136719,12.0141602
					s5.3896489,12.0141602,12.0136719,12.0141602c6.625,0,12.0146484-5.3896484,12.0146484-12.0141602
					S24.790432,3.4858398,18.165432,3.4858398z" />
				<path style={style.st1} d="M78.1654358,30.3417969c-8.1835938,0-14.8418007-6.6582031-14.8418007-14.8417969
					c0-8.184082,6.6582069-14.8422852,14.8418007-14.8422852c8.1845703,0,14.8427734,6.6582031,14.8427734,14.8422852
					C93.0082092,23.6835938,86.3500061,30.3417969,78.1654358,30.3417969z M78.1654358,3.6577148
					c-6.5292969,0-11.8417969,5.3125-11.8417969,11.8422852s5.3125,11.8417969,11.8417969,11.8417969
					c6.5302734,0,11.8427734-5.3120117,11.8427734-11.8417969S84.6957092,3.6577148,78.1654358,3.6577148z" />
				<path style={style.st1} d="M64.8402405,17.9912109h-8.4209023l-0.0351562-1.4643555
					c-0.0234375-0.7612305-0.4580078-7.4863281-8.0810547-7.4863281c-7.890625,0-8.9345703,7.3261719-8.9746094,7.6381836
					l-0.1699219,1.3066406l-7.3183594,0.0058594v-3h4.7646484c0.9443359-3.6728516,4.1972656-8.9506836,11.6982422-8.9506836
					c7.5097656,0,10.3017578,5.2324219,10.9345703,8.9506836h5.6025429V17.9912109z" />
				<circle style={style.st1} cx="2.3484442" cy="15.4998684" r="2.0086577" />
				<circle style={style.st1} cx="93.6515579" cy="15.4998684" r="2.0086577" />
				<path style={style.st1} d="M18.165432,30.5141602c-8.2783194,0-15.0136719-6.7353516-15.0136719-15.0141602
					S9.8871126,0.4858398,18.165432,0.4858398c8.2792969,0,15.0146484,6.7353516,15.0146484,15.0141602
					S26.4447289,30.5141602,18.165432,30.5141602z M18.165432,3.4858398c-6.6240225,0-12.0136719,5.3896484-12.0136719,12.0141602
					s5.3896489,12.0141602,12.0136719,12.0141602c6.625,0,12.0146484-5.3896484,12.0146484-12.0141602
					S24.790432,3.4858398,18.165432,3.4858398z" />
				<path style={style.st1} d="M78.1654358,30.3417969c-8.1835938,0-14.8418007-6.6582031-14.8418007-14.8417969
					c0-8.184082,6.6582069-14.8422852,14.8418007-14.8422852c8.1845703,0,14.8427734,6.6582031,14.8427734,14.8422852
					C93.0082092,23.6835938,86.3500061,30.3417969,78.1654358,30.3417969z M78.1654358,3.6577148
					c-6.5292969,0-11.8417969,5.3125-11.8417969,11.8422852s5.3125,11.8417969,11.8417969,11.8417969
					c6.5302734,0,11.8427734-5.3120117,11.8427734-11.8417969S84.6957092,3.6577148,78.1654358,3.6577148z" />
				<path style={style.st1} d="M64.8402405,17.9912109h-8.4209023l-0.0351562-1.4643555
					c-0.0234375-0.7612305-0.4580078-7.4863281-8.0810547-7.4863281c-7.890625,0-8.9345703,7.3261719-8.9746094,7.6381836
					l-0.1699219,1.3066406l-7.3183594,0.0058594v-3h4.7646484c0.9443359-3.6728516,4.1972656-8.9506836,11.6982422-8.9506836
					c7.5097656,0,10.3017578,5.2324219,10.9345703,8.9506836h5.6025429V17.9912109z" />
				<circle style={style.st1} cx="2.3484442" cy="15.4998684" r="2.0086577" />
				<circle style={style.st1} cx="93.6515579" cy="15.4998684" r="2.0086577" />
			</g>
		);
	}
}


function OldMan(props) {
	const oldmanglasses = {
		Cat,
		Tortoise,
		Chicken,
		Bunny,
		Pig,
	};

	const ThisOldMan = oldmanglasses[props.petType.name] || Cat;

	if (_.isUndefined(ThisOldMan)) {
		return null;
	}

	return <ThisOldMan {...props} />;
}

export default OldMan;



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Glasses/OldMan.js